import contentful from "libraries/contentful/client";
import { get } from "lodash";
import ContentfulEntry from "models/data/contentful/ContentfulEntry";
import ContentfulImage from "models/data/contentful/ContentfulImage";
import ContentfulAuthor from "models/data/contentful/ContentfulAuthor";
import ContentfulTextEssay from "models/data/contentful/ContentfulTextEssay";

class ContentfulStory {
  static default = {
    title: "",
    slug: "",
    summary: "",
    featuredImage: ContentfulImage.default,
    author: ContentfulAuthor.default,
    authorMultiple: [ContentfulAuthor.default],
    publicationDate: "2019-01-01",
    textEssay: ContentfulTextEssay.default,
    categories: [],
    relatedStories: [],
  };

  static id = (contentfulStory) => ContentfulEntry.id(contentfulStory);

  static title = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const title = get(fields, "title", ContentfulStory.default.title);
    return title;
  };

  static slug = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const slug = get(fields, "slug", ContentfulStory.default.slug);
    return slug;
  };

  static summary = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const summary = get(fields, "summary", ContentfulStory.default.summary);
    return summary;
  };

  static featuredImage = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const featuredImage = get(
      fields,
      "featuredImage",
      ContentfulStory.default.featuredImage
    );
    return featuredImage;
  };

  static author = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const author = get(fields, "author", ContentfulStory.default.author);
    return author;
  };

  static publicationDate = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const publicationDate = get(
      fields,
      "publicationDate",
      ContentfulStory.default.publicationDate
    );
    return publicationDate;
  };

  static textEssay = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const textEssay = get(
      fields,
      "textEssay",
      ContentfulStory.default.textEssay
    );
    return textEssay;
  };

  static categories = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const categories = get(
      fields,
      "categories",
      ContentfulStory.default.categories
    );
    return categories;
  };

  static authorMultiple = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const authorMultiple = get(
      fields,
      "authorMultiple",
      ContentfulStory.default.authorMultiple
    );
    return authorMultiple;
  };

  static relatedStories = (contentfulStory: any) => {
    const fields = ContentfulEntry.fields(contentfulStory);
    const stories = get(
      fields,
      "relatedStories",
      ContentfulStory.default.relatedStories
    );
    return stories;
  };

  static async fetch(storyId) {
    storyId = ContentfulStory.convertOldStoryId(storyId);
    const entries = await contentful.getEntries({
      content_type: "story",
      "sys.id": storyId,
    });
    const [contentfulStory] = [...get(entries, "items", [])];
    return contentfulStory;
  }

  static convertOldStoryId = (storyId) => {
    switch (storyId) {
      case "3UZiVOz88EtbhqCYo6erEE":
        return "76wNQszMGfqP6drFMEsLxT";
      case "26sHfJMDHaaUbjPvbx8hzq":
        return "78EkmoDjzxKL1hjCNj4m6m";
      case "3tKIe4b0pG7vLKTgQZOMLu":
        return "2qsHEf560R5BtEFX1e54TQ";
      case "2IgLxLtXyLHblnfKQBAsoG":
        return "5vVlHeLD88rYXKj6ohQT65";
      case "2fdXBkG5IBcUBun3ql6IVd":
        return "Z4gQeuyAYHiai65FqsACj";
      case "5HZ8xR0Noe0hrGL7LU3VYa":
        return "7gbJYi0DEFMSFqxKqAZ5O0";
      case "wAl2sNTREk4nP3otNn59F":
        return "2QAJLZnwQNvAEAy2kPQetU";
      case "1Hvyc5EbcaXWupEz9LtBOW":
        return "4YUyQ9wREGdKziO9IIcxLS";
      case "1XGZrawhgMbg3xYtcJJPcS":
        return "40p1k5lzKZ4rPVgzsBJI8m";
      case "FzsyrFRmxWAy1xsnE08Wi":
        return "x7lFNTbSsomrUhVhzvDVg";
      case "I1VfkDE2rcz2qHmhsG4LH":
        return "3X3cd6LLauKvOYbFswchf6";
      case "k4iHzSwrEm0wQTygSyWzn":
        return "4wjicYnl7Fc8GoiSCuKPPg";
      case "7z5ysc6408diGstyHApKfT":
        return "6TMWY3oN1QzDtthHGcUokl";
      case "51qxqBCMSjbwZkSlg4RLo3":
        return "5DfxCuKnVI8FSW5q5BdKFY";
      case "4QRoNjOivbF3lQldRHW3Zg":
        return "7N0p4UtORk4ZErpar7D6jF";
      case "5euZk24aSaym4sxa8efoGQ":
        return "6zh2FO9mniNXLeiM0DJKHs";
      case "5pEHzBoyEl3POom2qaDINO":
        return "6beYUFehSGcDnUx5nT7inG";
      case "3UQnPgsNe459o79JwgOu0k":
        return "39AA9EUTTxZBOh66lc0SVq";
      case "2xfBxFmoEgHBNE7QGNa3uG":
        return "7dmGwx5LqxeDSdnlyl5Fgp";
      case "4n3Qxj3p1tVew2Pv8iSCuf":
        return "5ue8rPxlb7oeEIH4LGPkz8";
      case "7qfg0Z95tGAJBJkTKEy8rp":
        return "4sxeX9OIqV1pZ6HZS1JECu";
      case "3F1byMNhuItRW5NUQz5CpV":
        return "6ii2EdifeRTHsT0tTTJl6m";
      case "24AKBBqIMk3rpjkLhQHiwq":
        return "42wXAprIZvcqWg5UAV8NLL";
      case "2SqYTgoFICHif9Li3nUngU":
        return "3NWZbEMhERv2EWtNSKeQZ7";
      case "3bj1Xmbar6sf2H6LZv3vG9":
        return "2BZ8ai6OyA4DKZpEbyGRoO";
      case "6rshr8DmGdgvNFpKQYiNm9":
        return "6rshr8DmGdgvNFpKQYiNm9";
      case "24gTPXtM8phX43PmmmGOFc":
        return "4z938VrUn887eBYZT3EDX";
      case "5W17aYPvZvhnUCDBvurwdF":
        return "3nlH8HcA0L1hXsBxNQD18q";
      case "6jqxwHTIQfNKjV34F9Gsil":
        return "74eqMM1I0DCDO4dNc87f1E";
      case "4F3Hc4Pd8cJtdMz678aD8Y":
        return "3lwODSaLHPikD7GSa0p5mu";
      case "aEJYIi8qEjCCY8FBdNuaC":
        return "6fOYA2um0NTm53yAsmasaE";
      case "2DiDRgnSasnIDdnA8HFEAm":
        return "69g1oZNRAluKlFgN0KX7y4";
      case "7f5OxbxWV57pMhv4fUShEc":
        return "39sKLCTxtMUE5gFnq7hXKo";
      case "FWWU8umkzwvH36B49JXmy":
        return "ZuqEynbcFpL0oevJXrzY7";
      case "1M3qUDgPjGEkAkMHpOI7yO":
        return "2Z1YvZiV7dhzz0McSsUcbc";
      case "7hqU0r8aVkd41AfKhEUh3i":
        return "6CIFR9fVf1gwfj9QkAo2RN";
      case "4nrxCAEs9zftph6zDxQh9T":
        return "6wQjgH9nvDOFo3vttDYZjZ";
      case "7q66xkCwtQzyLjYLUjhGGj":
        return "22fqh88bOKvU2uVP36BZIM";
      case "73oe8qALVz4yZH3C0RRi4B":
        return "5twrSVlVsThlY0nnXQhWaU";
      case "5kMVXGG2dK8CcCjP0gEup":
        return "5PXM9brGVOloudJxKBLm6W";
      case "591es3HDHGO6zXx63vwLMM":
        return "4FGx2RmhLkDIthcCOAtHfl";
      case "7JRS5LAT5w6FOoOOM6nQsh":
        return "6qJrvu5vRD37tULeOzZZMB";
      case "2aVyd9lo28PFr2dqYgMnvY":
        return "3yN4b3Pqy7vJjgbHiIOzxU";
      case "12EnAzU9Ytr7Q1oZm2djU5":
        return "2wNc0SaKzObnz1DcJUxc2T";
      case "5lGcqgrPD8FAcVtTTABpau":
        return "6bh0FW8BRTtyh9M7Q2quCK";
      case "6sS79XbIjDQnOIB5SFXej6":
        return "7p5iuT5EScN5e5WVo962Hl";
      case "2xhqgByawHx5YPIh26hWdK":
        return "6EzqK8QnT4eFLaGT5vhFV2";
      case "35XGe7qxDJo1jzX1JjMfOP":
        return "6sI0J2CWiJSHJngCegFeUa";
      case "4zEvlVxbxr1zSgFeyAGzeL":
        return "1v9TM9A3brxYMIFvliwvJS";
      case "2KPwFkKDIwTzejnMMMPZoL":
        return "6jF8BZ0P0nBOaka2JAX26i";
      case "30POBplKgKRB2bFPZZRiVD":
        return "16uao3pOEhNpUK6PUdX3ql";
      case "0GYO1iagCxOAk0998RCom":
        return "1bHoDu83ZE8jl0hWl6rhRn";
      case "7lIlBMd9089djItmG7MBgC":
        return "2a5YNiAssSWfeuBu9wpu8C";
      case "6RC4ngque38cImCVH4vN7x":
        return "5YCr0r5c9CUBtHTSsrSARK";
      case "6eFRa18FKyRLfF9h4bmLtf":
        return "2sRxN0kZ2Xpou4uv8Ivc7a";
      case "6QcTxO8xemmmgAMy2GcPYJ":
        return "1rtko35rUXpwRpmsmNJTAQ";
      case "6up1Es6KDcz1T2aB1Abi9z":
        return "7xvZ2QZtPwfnw3z9EpE1I6";
      case "66tHTDQCNvnafTdppgagba":
        return "5oE3rXq87HXxVD5kY5xmEd";
      case "5IwBS2NeY7kYUda9CCAsgx":
        return "5IbA5tfoLfRXi3iLrT0n2S";
      case "4dNXbHhyjTQZJgSXwIGTfU":
        return "MZl3ND3c6qeklMRl07Csm";
      case "4sqKAJUWNn2UkymddJLDHT":
        return "3dqUbRAwIqpzNQTAU4GRWS";
      case "7kLL9nMTz5r8NTbZnNhh6x":
        return "4G4svJeTO5tgIF7X2FbdPA";
      case "6AKtbjQGvra5vwaXkDJUjI":
        return "lfpRPUNqBDrG9IuAz8c2j";
      case "5OXBOMXCmi11RBecLrfx98":
        return "5NIw6SDlLqWn9hiZyl1XOw";
      case "7pJfNUmLoj8oyqHEZTI6PE":
        return "1yGgOh2JEQvBSPHxHyrY6O";
      case "507I8w0PZWOhZLiVYZunvP":
        return "1tFYX4HujOrPrkAbFwXgXS";
      case "7DvfjW3BPb3SB9o6rxhpBK":
        return "3mz2OtAR0xoOSPzsdk8GXW";
      case "Mg5LWKf4kV0FSNcr1YZqQ":
        return "367odSGaDUr52mUeALkmPV";
      case "3wc86wWvwt031tdEvwXFCf":
        return "1Um2T3SokaoPqcs6AqFj6S";
      case "2Nqy4OqtYYg4EZ8ii5ZJfo":
        return "6kUcePXjl0Lmty4cnNt38V";
      default:
        return storyId;
    }
  };
}

export default ContentfulStory;
